<script lang="ts">
  import { browser } from '$app/environment';

  export let shortcut: string;
  export let fontSize = "xs"
  export let spacing = true;
  export let classes = '';

  let isMac = false;
  let isMobile = false;

  if (browser) {
    //@ts-ignore
    isMac = navigator?.userAgentData?.platform === 'macOS' || /Mac/.test(navigator.userAgent);
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

$: displayShortcut = isMac ? shortcut.replace('Ctrl', '⌘') : shortcut;
</script>

{#if !isMobile}
  <kbd class="keyboard-shortcut px-1 py-0.5 rounded-md bg-black/10 opacity-60 tracking-tighter scale-90 font-semibold border border-ord-border/20 dark:bg-white/10 {spacing ? 'ml-1' : ''} text-{fontSize} {classes}">{displayShortcut}</kbd>
{/if}

<style>
  .keyboard-shortcut {
    font-family: 'Rethink', sans-serif;
  }
</style>
